import { Box } from "@chakra-ui/react";
import { ColorIcon, colors, GoiLogo, HStack, NextLink, VStack } from "goi_common";

export default function GuideBookBackCTASection() {
  return (
    <VStack width="100%" alignItems="center" gap="20px">
      <GoiLogo />
      <Box className="gray900">장례에 대해 더 많은 지식 보기</Box>
      <NextLink
        href="/guidebook/"
        css={{
          padding: "9px 25px",
          background: colors.gray100,
          borderRadius: "5px",
        }}
        event={{
          newGtm: {
            path: "gdb_tip",
            trigger_and_target: "footerCTA-uv_guide",
          },
        }}
      >
        <HStack alignItems="center" gap="8px">
          <ColorIcon
            color={colors.warmGray850}
            name="icon-arrow-right-circle-mono"
            size={18}
            css={{ transform: "rotate(180deg)" }}
          />
          <Box className="subtitle_14_sb" color={colors.warmGray850}>
            장례 가이드 목록으로
          </Box>
        </HStack>
      </NextLink>
    </VStack>
  );
}
